
export const modes = Object.freeze({
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
});

export default {};

